import { fetchJson } from './fetchJson.js'
import { shopifyRoute } from './shopifyRoutes.js'
import type { CartLineItem } from './cartItems.js'
import type { Attributes, Cart, CartUpdateInput } from '../types/Shopify.js'

const cartJsonHeaders = {
  'Content-Type': 'application/json',
} as const

export interface CartChangeInput {
  id: string
  quantity?: number
  properties?: Attributes
}

export function fetchCart(): Promise<Cart> {
  return fetchJson<Cart>(shopifyRoute('cart.js'), {
    method: 'GET',
    cache: 'no-store',
    credentials: 'same-origin',
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
}

export function postCartUpdate(data: CartUpdateInput): Promise<Cart> {
  return fetchJson<Cart>(shopifyRoute('cart/update.js'), {
    method: 'POST',
    headers: cartJsonHeaders,
    body: JSON.stringify(data),
  })
}

export function postCartClear(): Promise<Cart> {
  return fetchJson<Cart>(shopifyRoute('cart/clear.js'), {
    method: 'POST',
    headers: cartJsonHeaders,
  })
}

export function postCartChange(body: CartChangeInput): Promise<unknown> {
  return fetchJson(shopifyRoute('cart/change.js'), {
    method: 'POST',
    credentials: 'same-origin',
    headers: cartJsonHeaders,
    body: JSON.stringify(body),
  })
}

export function postCartAdd(items: CartLineItem[]): Promise<unknown> {
  return fetchJson(shopifyRoute('cart/add.js'), {
    method: 'POST',
    credentials: 'same-origin',
    headers: cartJsonHeaders,
    body: JSON.stringify({ items }),
  })
}
